import { Box, Flex, HStack, Icon, Stack, Text } from '@chakra-ui/react';

import { GoDotFill } from 'react-icons/go';

interface StackedLearnerDashboardContentListItemProps {
  id: string | undefined | null;
  imageUrl: string | undefined | null;
  title: string | undefined | null;
  formattedContentDuration: string;
  contentType: string;
  onClick: () => void;
  rightElement?: React.ReactNode;
}

export default function StackedLearnerDashboardContentListItem({
  id,
  imageUrl,
  title,
  formattedContentDuration,
  contentType,
  onClick,
  rightElement,
}: StackedLearnerDashboardContentListItemProps) {
  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      width="full"
      borderBottom="1px solid"
      borderColor="neutral.100"
      paddingX={2}
      paddingY={4}
      borderRadius="4px"
      _hover={{
        cursor: 'pointer',
        backgroundColor: 'neutral.100',
      }}
      onClick={onClick}
    >
      <HStack key={id} flex={1} spacing={4}>
        <Box
          height="39px"
          minHeight="39px"
          width="71px"
          minWidth="71px"
          backgroundColor="brand.primary"
          backgroundImage={`url(${imageUrl || ''})`}
          backgroundSize="cover"
          backgroundPosition="center"
          backgroundRepeat="no-repeat"
          borderRadius="4px"
        />

        <Stack>
          <Text fontSize="14px" fontWeight={500} color="baseBlack">
            {title}
          </Text>

          <HStack spacing={1}>
            {formattedContentDuration && (
              <>
                <Text
                  fontSize="12px"
                  fontWeight={600}
                  color="neutral.600"
                  textTransform="uppercase"
                >
                  {formattedContentDuration}
                </Text>

                <Icon as={GoDotFill} boxSize={2} color="neutral.600" />
              </>
            )}

            <Text fontSize="12px" fontWeight={600} color="neutral.600" textTransform="uppercase">
              {contentType}
            </Text>
          </HStack>
        </Stack>
      </HStack>

      {rightElement}
    </Flex>
  );
}
